module.exports = __webpack_public_path__ + "img/grooming5.acd1d953.jpg";